import { ReviewsActions } from './actions'
import {
  REVIEWS_STATE,
  FETCH_REVIEWS_REQUEST,
  FETCH_REVIEWS_SUCCESS,
  FETCH_REVIEWS_FAILURE,
  SET_REVIEWS_FILTER,
} from './constants'
import stateBase from './state'

const initialState = stateBase[REVIEWS_STATE]

const reducer = (state = initialState, action: ReviewsActions) => {
  switch (action.type) {
    case SET_REVIEWS_FILTER:
      return {
        ...state,
        filter: action.payload.filter,
      }
    case FETCH_REVIEWS_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: action.payload.page <= 1,
      }
    case FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        data: {
          property: action.payload.property,
          pagination: action.payload.pagination,
          reviews: state.data.reviews.length === 0 ? action.payload.reviews : state.data.reviews,
          reviewsPaginated:
            action.payload.pagination.page > 1
              ? [...state.data.reviewsPaginated, ...action.payload.reviews]
              : action.payload.reviews,
        },
      }

    case FETCH_REVIEWS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        isFetching: false,
      }

    default:
      return state
  }
}

export default reducer
